<template>
    <div id="app" class="bg-gray-100">
        <link rel="preconnect" href="https://fonts.googleapis.com"/>
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/>
        <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;700&family=Merriweather&display=swap" rel="stylesheet"/>
        <Header/>
        <div class="container mx-auto">
        <router-view />
    </div>
    <ScrollUpButton v-show="showScrollUpButton" class="invisible sm:visible"/>
    <Footer/>
</div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import ScrollUpButton from './components/ScrollUpButton.vue'

export default {
    name: 'App',
    data() {
        return {
            showScrollUpButton: false
        }
    },
    methods: {
        handleScroll (event) {
            // Any code to be executed when the window is scrolled
            if (window.scrollY > 200) {
                this.showScrollUpButton = true
            } else {
                this.showScrollUpButton = false
            }
        }
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    components:{
        Header, Footer, ScrollUpButton
    }
}
</script>

<style>
    body{
        font-family: "Merriweather", Serif;
    }
</style>
